module.exports = __webpack_public_path__ + "static/media/pokemon25.a3d17c6a.jpg";